import { defineComponent as oe, watchEffect as ne, ref as y, toRef as S, computed as c, provide as ie, h as a, withDirectives as re, Transition as se } from "vue";
import ae from "./ghl-ui.es947.js";
import { drawerInjectionKey as de } from "./ghl-ui.es948.js";
import le from "./ghl-ui.es949.js";
import { warnOnce as d } from "./ghl-ui.es819.js";
import ce from "./ghl-ui.es820.js";
import he from "./ghl-ui.es687.js";
import k from "./ghl-ui.es821.js";
import v from "./ghl-ui.es686.js";
import { formatLength as C } from "./ghl-ui.es950.js";
import { useThemeClass as ue } from "./ghl-ui.es823.js";
import fe from "./ghl-ui.es734.js";
import me from "./ghl-ui.es693.js";
import ge from "./ghl-ui.es951.js";
import { call as r } from "./ghl-ui.es860.js";
import { eventEffectNotPerformed as pe } from "./ghl-ui.es934.js";
import { useIsComposing as we } from "./ghl-ui.es952.js";
const be = Object.assign(Object.assign({}, k.props), {
  show: Boolean,
  width: [Number, String],
  height: [Number, String],
  placement: {
    type: String,
    default: "right"
  },
  maskClosable: {
    type: Boolean,
    default: !0
  },
  showMask: {
    type: [Boolean, String],
    default: !0
  },
  to: [String, Object],
  displayDirective: {
    type: String,
    default: "if"
  },
  nativeScrollbar: {
    type: Boolean,
    default: !0
  },
  zIndex: Number,
  onMaskClick: Function,
  scrollbarProps: Object,
  contentClass: String,
  contentStyle: [Object, String],
  trapFocus: {
    type: Boolean,
    default: !0
  },
  onEsc: Function,
  autoFocus: {
    type: Boolean,
    default: !0
  },
  closeOnEsc: {
    type: Boolean,
    default: !0
  },
  blockScroll: {
    type: Boolean,
    default: !0
  },
  maxWidth: Number,
  maxHeight: Number,
  minWidth: Number,
  minHeight: Number,
  resizable: Boolean,
  defaultWidth: {
    type: [Number, String],
    default: 251
  },
  defaultHeight: {
    type: [Number, String],
    default: 251
  },
  onUpdateWidth: [Function, Array],
  onUpdateHeight: [Function, Array],
  "onUpdate:width": [Function, Array],
  "onUpdate:height": [Function, Array],
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onAfterEnter: Function,
  onAfterLeave: Function,
  /** @deprecated */
  drawerStyle: [String, Object],
  drawerClass: String,
  target: null,
  onShow: Function,
  onHide: Function
}), Ae = oe({
  name: "Drawer",
  inheritAttrs: !1,
  props: be,
  setup(e) {
    process.env.NODE_ENV !== "production" && ne(() => {
      e.drawerStyle !== void 0 && d("drawer", "`drawer-style` is deprecated, please use `style` instead."), e.drawerClass !== void 0 && d("drawer", "`drawer-class` is deprecated, please use `class` instead."), e.target !== void 0 && d("drawer", "`target` is deprecated, please use `to` instead."), e.onShow !== void 0 && d("drawer", "`on-show` is deprecated, please use `on-update:show` instead."), e.onHide !== void 0 && d("drawer", "`on-hide` is deprecated, please use `on-update:show` instead.");
    });
    const {
      mergedClsPrefixRef: i,
      namespaceRef: H,
      inlineThemeDisabled: f
    } = ce(e), m = he(), h = k("Drawer", "-drawer", le, ge, e, i), g = y(e.defaultWidth), p = y(e.defaultHeight), z = v(S(e, "width"), g), x = v(S(e, "height"), p), B = c(() => {
      const {
        placement: t
      } = e;
      return t === "top" || t === "bottom" ? "" : C(z.value);
    }), F = c(() => {
      const {
        placement: t
      } = e;
      return t === "left" || t === "right" ? "" : C(x.value);
    }), R = (t) => {
      const {
        onUpdateWidth: o,
        "onUpdate:width": n
      } = e;
      o && r(o, t), n && r(n, t), g.value = t;
    }, U = (t) => {
      const {
        onUpdateHeight: o,
        "onUpdate:width": n
      } = e;
      o && r(o, t), n && r(n, t), p.value = t;
    }, E = c(() => [{
      width: B.value,
      height: F.value
    }, e.drawerStyle || ""]);
    function w(t) {
      const {
        onMaskClick: o,
        maskClosable: n
      } = e;
      n && u(!1), o && o(t);
    }
    function W(t) {
      w(t);
    }
    const O = we();
    function M(t) {
      var o;
      (o = e.onEsc) === null || o === void 0 || o.call(e), e.show && e.closeOnEsc && pe(t) && !O.value && u(!1);
    }
    function u(t) {
      const {
        onHide: o,
        onUpdateShow: n,
        "onUpdate:show": l
      } = e;
      n && r(n, t), l && r(l, t), o && !t && r(o, t);
    }
    ie(de, {
      isMountedRef: m,
      mergedThemeRef: h,
      mergedClsPrefixRef: i,
      doUpdateShow: u,
      doUpdateHeight: U,
      doUpdateWidth: R
    });
    const b = c(() => {
      const {
        common: {
          cubicBezierEaseInOut: t,
          cubicBezierEaseIn: o,
          cubicBezierEaseOut: n
        },
        self: {
          color: l,
          textColor: N,
          boxShadow: A,
          lineHeight: P,
          headerPadding: I,
          footerPadding: D,
          borderRadius: T,
          bodyPadding: j,
          titleFontSize: $,
          titleTextColor: L,
          titleFontWeight: _,
          headerBorderBottom: V,
          footerBorderTop: K,
          closeIconColor: q,
          closeIconColorHover: G,
          closeIconColorPressed: J,
          closeColorHover: Q,
          closeColorPressed: X,
          closeIconSize: Y,
          closeSize: Z,
          closeBorderRadius: ee,
          resizableTriggerColorHover: te
        }
      } = h.value;
      return {
        "--n-line-height": P,
        "--n-color": l,
        "--n-border-radius": T,
        "--n-text-color": N,
        "--n-box-shadow": A,
        "--n-bezier": t,
        "--n-bezier-out": n,
        "--n-bezier-in": o,
        "--n-header-padding": I,
        "--n-body-padding": j,
        "--n-footer-padding": D,
        "--n-title-text-color": L,
        "--n-title-font-size": $,
        "--n-title-font-weight": _,
        "--n-header-border-bottom": V,
        "--n-footer-border-top": K,
        "--n-close-icon-color": q,
        "--n-close-icon-color-hover": G,
        "--n-close-icon-color-pressed": J,
        "--n-close-size": Z,
        "--n-close-color-hover": Q,
        "--n-close-color-pressed": X,
        "--n-close-icon-size": Y,
        "--n-close-border-radius": ee,
        "--n-resize-trigger-color-hover": te
      };
    }), s = f ? ue("drawer", void 0, b, e) : void 0;
    return {
      mergedClsPrefix: i,
      namespace: H,
      mergedBodyStyle: E,
      handleOutsideClick: W,
      handleMaskClick: w,
      handleEsc: M,
      mergedTheme: h,
      cssVars: f ? void 0 : b,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender,
      isMounted: m
    };
  },
  render() {
    const {
      mergedClsPrefix: e
    } = this;
    return a(fe, {
      to: this.to,
      show: this.show
    }, {
      default: () => {
        var i;
        return (i = this.onRender) === null || i === void 0 || i.call(this), re(a("div", {
          class: [`${e}-drawer-container`, this.namespace, this.themeClass],
          style: this.cssVars,
          role: "none"
        }, this.showMask ? a(se, {
          name: "fade-in-transition",
          appear: this.isMounted
        }, {
          default: () => this.show ? a("div", {
            "aria-hidden": !0,
            class: [`${e}-drawer-mask`, this.showMask === "transparent" && `${e}-drawer-mask--invisible`],
            onClick: this.handleMaskClick
          }) : null
        }) : null, a(ae, Object.assign({}, this.$attrs, {
          class: [this.drawerClass, this.$attrs.class],
          style: [this.mergedBodyStyle, this.$attrs.style],
          blockScroll: this.blockScroll,
          contentStyle: this.contentStyle,
          contentClass: this.contentClass,
          placement: this.placement,
          scrollbarProps: this.scrollbarProps,
          show: this.show,
          displayDirective: this.displayDirective,
          nativeScrollbar: this.nativeScrollbar,
          onAfterEnter: this.onAfterEnter,
          onAfterLeave: this.onAfterLeave,
          trapFocus: this.trapFocus,
          autoFocus: this.autoFocus,
          resizable: this.resizable,
          maxHeight: this.maxHeight,
          minHeight: this.minHeight,
          maxWidth: this.maxWidth,
          minWidth: this.minWidth,
          showMask: this.showMask,
          onEsc: this.handleEsc,
          onClickoutside: this.handleOutsideClick
        }), this.$slots)), [[me, {
          zIndex: this.zIndex,
          enabled: this.show
        }]]);
      }
    });
  }
});
export {
  Ae as default,
  be as drawerProps
};
